import React, { Component } from 'react'
import { IoMdShare, FaFacebookSquare, FaTwitterSquare } from 'react-icons/all'
import { FacebookShareButton, TwitterShareButton } from 'react-share'
import './style.css'


export default class ShareTool extends Component {
    getIconView() {
        if (window.config.toolbar?.share?.icon != null)
            return <img src={`${process.env.PUBLIC_URL}/data/${window.config.toolbar?.share?.icon}`} />
        return <IoMdShare />
    }

    render() {
        if (!window.config.toolbar?.share?.display) return "";
        var url = window.config.toolbar?.share?.url;
        return (
            <div className="tool-item" id="tool-share">
                <div className="item-icon">
                    {this.getIconView.call(this)}
                </div>
                <div className="item-widget">
                    <div className="share-type-container">
                        <FacebookShareButton url={url}>
                            <FaFacebookSquare />
                        </FacebookShareButton>
                        <TwitterShareButton url={url}>
                            <FaTwitterSquare />
                        </TwitterShareButton>
                    </div>
                </div>
            </div>

        )
    }
}
